import { mediaQuery } from 'modules/utils';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { theme } from '../theme';
import { BodyText } from '../typography';

export const StyledBreadcrumbContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  margin-bottom: 1.5rem;

  ${mediaQuery('md')} {
    margin-bottom: 1rem;
  }
`;

export const StyledBreadcrumbText = styled(BodyText)`
  white-space: nowrap;
  margin-bottom: 0;
`;

export const StyledLink = styled(Link)`
  color: ${({theme}) => theme.colors.primaryT2};
  text-decoration: var(--text-underline);

  :hover {
    color: ${({theme}) => theme.colors.primaryT1};
  }
`;

export const StyledSlash = styled.span`
  margin-left: 0.563rem;
  margin-right: 0.625rem;
`;
